import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { throwError, Observable, pipe } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { TupApiServiceBase } from '@telmar-global/tup-auth';

import { Logger } from 'src/app/logger';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class DevportalApiService extends TupApiServiceBase {

  constructor(
    http: HttpClient,
  ) {
    super( http, environment );
  }

  request<T>( method: string, url: string, options?: any ) : Observable<T> {

    return super.request( method, url, options )
      .pipe( this.handleHttpErrorResponse(method, url, options) ) as Observable<T>;
  }

  private handleHttpErrorResponse (method, url, options) {
    return pipe(

      catchError((error) => {

        // log developer-friendly error message
        Logger.error(`There was an error communicating with app server: "${JSON.stringify(error)}" Triggered while trying to reach: ${url} with ${method}. HttpClient options: ${JSON.stringify(options)}`);
        // Logger.error(error);

        // return an observable with a user-friendly error message
        let error_message = 'please try again later';
        if( error.error?.message ) error_message = `"${error.error?.message}"`;

        return throwError(
          `There was an error trying to talk to the application server, ${error_message}.`);
      })
    )
  }
}
